export default function handleTabNavigation() {
  if ($(".tab-nav__item")) {
    if (window.location.hash) {
      $(".tab-nav__item").removeClass("tab-nav__item--active");
      $(".tab").removeClass("tab--visible");
      jQuery.each($(".tab-nav__item"), function (_, value) {
        const href = `#${value.href.split("#")[1]}`;

        if (href === window.location.hash) {
          $(window.location.hash).addClass("tab--visible");
          $(value).addClass("tab-nav__item--active");
        }
      });
    }

    $(".tab-nav__item").on("click", function (e) {
      e.preventDefault();
      const target = $(this).attr("href");
      history.pushState(null, null, target);
      $(".tab-nav__item").removeClass("tab-nav__item--active");
      $(this).addClass("tab-nav__item--active");
      $(".tab").removeClass("tab--visible");
      $(target).addClass("tab--visible");
    });
  }
}

handleTabNavigation();
